import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  // 定义状态
  config: {
    apiUrl: 'http://localhost:8080'
  },
  state: {
    author: 'Wise Wrong'
  }
})
export default store



// WEBPACK FOOTER //
// ./src/vuex/store.js